import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OemPortalModule } from '../oem-portal/oem-portal.module';
import { ReviewPartnerContentComponent } from './Review-partner-content/review-partner-content.component';
import { ApprovedPartnerContentComponent } from './Approved-partner-content/approved-partner-content.component';
import { PartnersComponent } from './Partners/partners.component';
import { AuthorsComponent } from './Authors/authors.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { PartnerContentComponent } from './partner-content/partner-content.component';
import { ReviewCommentComponent } from './Review-partner-content/review-comment/review-comment/review-comment.component';
import { ApprovedPartnerContentViewComponent } from './Approved-partner-content/approved-partner-content-view/approved-partner-content-view.component';
import { ViewPagesComponent } from '../../../app/modules/partner-content/Review-partner-content/review-comment/review-comment/view-pages/view-pages/view-pages.component';
import { AssetLibraryModule } from '../../modules/asset-library/asset-library.module';
import { NgSelectModule } from '@ng-select/ng-select';
import { PipeUtilModule } from '../pipes/pipe-util/pipe-util.module';
import { DateTimeZoneModule } from '../../common/components/date-time-zone/date-time-zone.component/date-time-zone.module';
import { AcknowlegementDialogComponent } from '../../common/components/acknowlegement-dialog/acknowlegement-dialog/acknowlegement-dialog.component';
import { SystemIdsComponent } from './System-IDs/system-ids/system-ids.component';
import { DeleteModule } from '../../common/components/delete/delete.module';


@NgModule({
  declarations: [ReviewPartnerContentComponent, ApprovedPartnerContentComponent, PartnerContentComponent, AcknowlegementDialogComponent,
    PartnersComponent, AuthorsComponent, ReviewCommentComponent, ApprovedPartnerContentViewComponent, ViewPagesComponent, SystemIdsComponent],
  imports: [
    CommonModule,
    FormsModule, ReactiveFormsModule, NgbModule, OemPortalModule, AssetLibraryModule, NgSelectModule,PipeUtilModule,DateTimeZoneModule, DeleteModule
  ]
})
export class PartnerContentModule { }
